export default "__VITE_ASSET__BC7RWNU$__"